module.exports = __webpack_public_path__ + "static/media/faves.b4c2cc27.webp";